import gql from "graphql-tag";

export const ActivityLog = {
	QUERY: {
		GETACTIVITYLOGS: gql`
			query GetActivityLog($page: Int, $limit: Int) {
				GetActivityLog(page: $page, limit: $limit) {
					docs {
						staff {
							id
							first_name
							middle_name
							surname
							mobile
							image
							designation {
								id
								name
							}
							department {
								id
								name
							}
							type {
								id
								name
							}
							admin
							site {
								id
								name
							}
						}
						id
						summary
						ip
						activity
						datetime
					}
					page
					limit
					totalDocs
					totalPages
					nextPage
					prevPage
				}
			}
		`
	},
	MUTATION: {}
};
